<template>
	<div class="container account_wallet">
		<div class="content">
			<div class="card">
				<h4 class="title mb_20">{{ $t('account-wallet.title2') }}</h4>
				<div class="d_flex slide_area mb_20">
					<ul class="d_flex asset_area">
						<li>
							<input
								type="radio"
								id="asset1"
								class="radio_asset"
								v-model="selectedAsset"
								name="asset"
								value="1r"
								@change="checkAsset"
							/>
							<label class="box" for="asset1">
								<span class="coin_icon mt_15 JPYS"></span>
								<span class="coin_name">
									JPYS<br />
									<span>JPWORLDPAY</span>
								</span>
							</label>
						</li>
						<li>
							<input
								type="radio"
								id="asset2"
								class="radio_asset"
								v-model="selectedAsset"
								name="asset"
								value="2r"
								@change="checkAsset"
							/>
							<label class="box" for="asset2">
								<span class="coin_icon mt_15 BTC"></span>
								<span class="coin_name">
									BTC<br />
									<span>비트코인</span>
								</span>
							</label>
						</li>
					</ul>
				</div>

				<!--        account assets-->
				<div class="bg_black_box">
					<div class="d_flex justify_between">
						<div class="d_flex align_items_center">
							<div class="coin_icon type_01 mb_0 JPYS"></div>
							<p class="coin_name fs_18">
								JPYS<br />
								<span>JPWORLDPAY</span>
							</p>
						</div>

						<div class="balance_area align_items_end">
							<div class="quantity mr_5">4,612,000</div>
							<span class="currency">JPYS</span>
						</div>
					</div>

					<template v-if="myWallet === 'JPYS'">
						<div class="button_area justify_between">
							<button class="button_blue">
								{{ $t('account-wallet.btn_charge') }}
							</button>
							<div>
								<button class="button_white mr_5" @click="withdrawModal = true">
									{{ $t('account-wallet.btn_jpys_send') }}
								</button>
								<button class="button_bg_red">
									{{ $t('account-wallet.btn_receive') }}
								</button>
							</div>
						</div>
					</template>

					<template>
						<div class="button_area">
							<button class="button_white mr_5">
								{{ $t('account-wallet.btn_other_send') }}
							</button>
							<button class="button_bg_red">
								{{ $t('account-wallet.btn_receive') }}
							</button>
						</div>
					</template>
				</div>
				<!--        account assets-->
				<span class="divide_line"></span>

				<template v-if="myWallet === 'JPYS'">
					<p style="text-align: center; margin-top: 126px">
						{{ $t('account-wallet.text1') }}
					</p>
				</template>

				<template v-else>
					<div class="qr_area">
						<p>{{ $t('account-wallet.my_wallet') }}</p>
						<div class="qr_image_wrap">
							<img src="@/assets/images/qr_sample.jpg" alt="" />
						</div>
						<p class="address">12345-456-456464</p>
						<button class="button_copy">
							{{ $t('account-wallet.btn_copy') }}
						</button>
					</div>
				</template>
			</div>
		</div>
	</div>

	<ModalView v-if="withdrawModal" @closeModal="withdrawModal = false">
		<h4 class="title">{{ $t('account-wallet.modal.title1') }}</h4>
		<div class="text_box">
			<p>
				{{ $t('account-wallet.modal.text1') }}<br />
				{{ $t('account-wallet.modal.text2') }}<br />
				{{ $t('account-wallet.modal.text3') }}
			</p>
		</div>
		<h4 class="title">{{ $t('account-wallet.modal.title2') }}</h4>
		<div class="text_box">
			<p>
				{{ $t('account-wallet.modal.text4') }}
			</p>
		</div>
		<p class="caution">
			{{ $t('account-wallet.modal.caution') }}
		</p>
		<div class="button_area">
			<button class="fc_black" @click="withdrawModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="fc_red" @click="withdrawModal2 = true">
				{{ $t('button.next') }}
			</button>
		</div>
	</ModalView>
	<ModalView v-if="withdrawModal2" @closeModal="withdrawModal2 = false">
		<div class="text_box">
			<p>
				{{ $t('account-wallet.modal.text5') }}<br />
				{{ $t('account-wallet.modal.text6') }}<br />
				{{ $t('account-wallet.modal.text7') }} <br />
				{{ $t('account-wallet.modal.text8') }}<br />
				{{ $t('account-wallet.modal.text9') }}<br />
				{{ $t('account-wallet.modal.text10') }}
			</p>
		</div>
		<div class="box_check">
			<label class="checkbox_container">
				{{ $t('account-wallet.modal.check1') }}
				<input type="checkbox" />
				<span class="checkmark"></span>
			</label>
		</div>
		<div class="button_area">
			<button class="fc_black" @click="withdrawModal2 = false">
				{{ $t('button.back') }}
			</button>
			<button class="fc_red">{{ $t('button.request') }}</button>
		</div>
	</ModalView>
</template>

<script>
import ModalView from '@/components/Layout/ModalView';
export default {
	name: 'Account',
	components: {
		ModalView,
	},
	data() {
		return {
			myWallet: 'JPYS',
			selectedAsset: '',
			withdrawModal: false,
			withdrawModal2: false,
		};
	},
	methods: {
		checkAsset(e) {
			let selected = e.target.value;
			console.log('selected : ', selected);
		},
	},
};
</script>
